// Local translations
export const T = {
  en_GB: {
    textContent: "Text Content",
    insertField: "Insert Field",
    clientFields: "Client Fields",
    customFields: "Custom Fields",
    quizFields: "Quiz Results",
    quizOverrideFields: "Quiz overrides",
    quizExternalFields: "Quiz external results",
    ownerFields: "Owner Fields",
    goalFields: "Goal Fields",
    portfolioFields: "Portfolio Fields",
    portfolioMandateStatus: "Portfolio Mandate Status",
    portfolioMandateDeviationNote: "Portfolio Mandate Deviation Note",
    portfolioMandateDecidedBy: "Portfolio Mandate Decided By",
    portfolioMandateDecidedAt: "Portfolio Mandate Decided At",
    portfolioModelDeviation: "Portfolio Model Deviation",
    portfolioModelRiskScore: "Portfolio Model Risk Score",
    portfolioGoalRiskScore: "Portfolio Goal Risk Score",
    flowFields: "Flow Fields",
    flow: "Flow",
    document: "Document",
    placeholder: "Enter text content...",
    formattingHelp: "Supports formatting: *bold*, _italic_, - bullets, + numbered lists",
    alignment: "Alignment",
    fontSize: "Font Size (pt)",
    maxWidth: "Max Width (cm)",
    textColor: "Color",
    reset: "Reset",
    left: "Left",
    center: "Center",
    right: "Right",
    default: "Default",
    full: "Full",
    goal: "Goal",
    portfolio: "Portfolio",
    // Client field labels
    name: "Name",
    cancelReason: "Cancel Reason",
    expectingChanges: "Expecting Financial Changes",
    expectingChangesNote: "Expecting Financial Changes Note",
    type: "Type",
    email: "Email",
    mobilePhone: "Mobile Phone",
    ssn: "SSN",
    orgId: "Org ID",
    country: "Country",
    groupMembers: "Group members",
    representative: "Representative",
    owner: "Owner",
    // Owner field labels
    phoneNumber: "Phone Number",
    title: "Title",
    signature: "Signature",
    // Goal field labels
    goalName: "Goal Name",
    portfolioName: "Portfolio Name",
    goalType: "Goal Type",
    goalDescription: "Goal Description",
    riskScore: "Risk Score",
    mandateName: "Mandate Name",
    mandateStatus: "Mandate Status",
    mandateSource: "Mandate Source",
    mandateOrigin: "Mandate Origin",
    mandateMode: "Mandate Mode",
    existingMandateName: "Existing Mandate Name",
    mandateDeviationNote: "Mandate Deviation Note",
    mandateDecidedBy: "Mandate Decided By",
    mandateDecidedAt: "Mandate Decided At",
    // Document fields
    today: "Today",
    // Validation
    validationError: "Please enter text content",
  },
  nb_NO: {
    textContent: "Tekstinnhold",
    insertField: "Sett inn felt",
    clientFields: "Kundefelt",
    customFields: "Egendefinerte felt",
    quizFields: "Quizresultater",
    quizOverrideFields: "Quiz-overstyringer",
    quizExternalFields: "Eksterne quiz-resultater",
    goalFields: "Målfelt",
    portfolioFields: "Porteføljefelt",
    portfolioMandateStatus: "Porteføljens mandatstatus",
    portfolioMandateDeviationNote: "Porteføljens mandatavvik begrunnelse",
    portfolioMandateDecidedBy: "Porteføljens mandatavvik akseptert av",
    portfolioMandateDecidedAt: "Porteføljens mandatavvik akseptert dato",
    portfolioModelDeviation: "Modellportefølje fra annen risikoscore",
    portfolioModelRiskScore: "Modellporteføljens risikoscore",
    portfolioGoalRiskScore: "Målets risikoscore",
    flowFields: "Flytfelt",
    ownerFields: "Eierfelt",
    flow: "Flyt",
    document: "Dokument",
    placeholder: "Skriv inn tekstinnhold...",
    formattingHelp: "Støtter formatering: *fet*, _kursiv_, - punktlister, + nummererte lister",
    alignment: "Justering",
    fontSize: "Skriftstørrelse (pt)",
    maxWidth: "Maks bredde (cm)",
    textColor: "Farge",
    reset: "Tilbakestill",
    left: "Venstre",
    center: "Midtstilt",
    right: "Høyre",
    default: "Standard",
    full: "Full",
    goal: "Mål",
    portfolio: "Portefølje",
    // Client field labels
    name: "Navn",
    cancelReason: "Kanselleringsårsak",
    expectingChanges: "Forventede økonomiske endringer",
    expectingChangesNote: "Notat om forventede endringer",
    type: "Type",
    email: "E-post",
    mobilePhone: "Mobiltelefon",
    ssn: "Fødselsnummer",
    orgId: "Org.nr",
    country: "Land",
    groupMembers: "Gruppemedlemmer",
    representative: "Representant",
    owner: "Eier",
    // Owner field labels
    phoneNumber: "Telefonnummer",
    title: "Tittel",
    signature: "Signatur",
    // Goal field labels
    goalName: "Målnavn",
    portfolioName: "Porteføljenavn",
    goalType: "Måltype",
    goalDescription: "Målbeskrivelse",
    riskScore: "Risikoscore",
    mandateName: "Mandatnavn",
    mandateStatus: "Mandatstatus",
    mandateSource: "Mandatkilde",
    mandateOrigin: "Mandatopprinnelse",
    mandateMode: "Mandatmodus",
    existingMandateName: "Eksisterende mandatnavn",
    mandateDeviationNote: "Mandatavvik begrunnelse",
    mandateDecidedBy: "Mandatavvik akseptert av",
    mandateDecidedAt: "Mandatavvik akseptert dato",
    // Document fields
    today: "I dag",
    // Validation
    validationError: "Vennligst skriv inn tekstinnhold",
  },
} as const;
